import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { NavLink } from 'react-router-dom'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'
import { useAppSelector } from '../../../../../store/hooks'
import { selectSelectedMeetingTemplate } from '../../../../../store/meetingSummary/meetingTemplates'

export interface MeetingScoreItemsProps {
  title: string
  description: string
  value: boolean | null
  valueKey: string
  infoNeeded: boolean
  islastRow: boolean
}

export const MeetingScoreItems: React.FC<MeetingScoreItemsProps> = ({ title, description, value, valueKey, infoNeeded, islastRow }) => {
  const { hasQuota } = useZocksQuota()
  const sentimentAnalysisEnabled = hasQuota('ai.sentimentAnalysis.value')
  const meetingTemplate = useAppSelector(selectSelectedMeetingTemplate)

  if (!meetingTemplate) {
    return <div></div>
  }

  return (
    <Row className={`${!islastRow ? 'border-bottom border-1 zocks-border-color-gray-200' : ''} zocks-p-1.25 w-100`}>
      <Col className='flex-column'>
        <Row className='w-100'>
          <Col xs='auto' className='pe-0 pb-0'>
            <h6>{title}</h6>
          </Col>
          <Col className='d-flex align-items-center'>
            {infoNeeded && (
              <NavLink
                className=' zocks-text-primary-dark p-0'
                to={`/workspace/setup/meeting-types/meeting-type/details/${meetingTemplate?.id}/presets/scorecard`}
              >
                <Tooltip className='zocks-text-gray-500' placement='right' title='You can customize the primary aspect you want to measure in this section.'>
                  <div className='lead-extra-small bold d-flex py-1 px-2 justify-content-center align-items-center zocks-gap-0.75 zocks-text-primary-dark zocks-bg-color-primary-light zocks-border-0.25'>
                    Customize
                  </div>
                </Tooltip>
              </NavLink>
            )}
          </Col>
        </Row>
        <div className='paragraph-medium-extended zocks-text-gray-600'>{description}</div>
      </Col>
      <Col className='d-flex justify-content-end align-items-center'>
        {value ? (
          <div className=' bold lead-extra-small d-flex py-1 px-2 justify-content-center align-items-center zocks-gap-0.75 zocks-text-success zocks-bg-color-success-background zocks-border-0.25'>
            Excellent
          </div>
        ) : !value ? (
          <div className='bold lead-extra-small d-flex py-1 px-2 justify-content-center align-items-center zocks-gap-0.75 zocks-text-warning-text zocks-bg-color-warning zocks-border-0.25'>
            Needs Work
          </div>
        ) : value == null && valueKey === 'sentiment' && !sentimentAnalysisEnabled ? (
          <div className='paragraph-small py-1 px-2 gap-1 text-end'>
            <span>Meeting Sentiment Analysis is unavailable for the entire account. Go to the </span>
            <NavLink className='button-link-small zocks-text-gray-900 p-0' to={'/workspace/setup/settings'} target='_blank'>
              Settings
            </NavLink>
          </div>
        ) : value == null && valueKey === 'sentiment' && sentimentAnalysisEnabled ? (
          <div className='paragraph-small d-flex py-1 px-2 zocks-gap-0.75 text-end'>
            Meeting Sentiment Analysis was not active for the account at the time of this meeting
          </div>
        ) : value == null && valueKey === 'overUnderTime' ? (
          <div className='paragraph-small d-flex py-1 px-2 zocks-gap-0.75 text-end'>This score only available for scheduled meetings through calendar</div>
        ) : null}
      </Col>
    </Row>
  )
}
